import React, { FC } from 'react'
import type { ConnectorProps as GalleryProps } from '../../connectors/Gallery/Thumbnails'
import GalleryThumbnailsConnector from '../../connectors/Gallery/Thumbnails'
import ARExperience from '../ARExperience/Desktop'
import { AddArtwork, Thumbnails, Thumb, ViewInARoomThumb } from '../styles/gallery/thumbnails'
import {
  PlusIcon,
  /* ViewInARoomIcon */
} from '../styles/icons'
import ViewInARoomSized from './ViewInARoomThumb'
import {
  GALLERY_ITEM_TYPE_ARTIST_VIDEO,
  GALLERY_ITEM_TYPE_VIEW_IN_A_ROOM_IMAGE,
} from '../../constants'
type Props = GalleryProps & {
  clickThumbnail: (index: number) => void
  currentItem: number
  rendered: boolean
}

const Component: FC<Props> = (props) => {
  const {
    canEditArtwork,
    clickAddArtworkThumbnail,
    clickThumbnail,
    currentItem,
    currentTab,
    galleryItems,
    isARExperienceAvailable,
    isClientReady,
    rendered,
    selectedProduct,
    title,
  } = props

  if (galleryItems.length <= 1 && !canEditArtwork && !isARExperienceAvailable) {
    return null
  }

  /** @access private extracted to share <Thumb> wrapper */
  const wrapWithThumbComponent = (
    currentTab: string,
    index: number,
    description: string,
    currentItem: number,
    content: React.ReactElement
  ) => {
    return (
      <Thumb
        key={`thumb-${currentTab}-${index}`}
        index={index}
        alt={description}
        selected={currentItem === index}
        onClick={() => clickThumbnail(index)}
      >
        {content}
      </Thumb>
    )
  }

  return (
    <Thumbnails data-type='thumbnails'>
      {galleryItems.map((galleryItem, index) => {
        const { galleryItemType } = galleryItem

        switch (galleryItemType) {
          case GALLERY_ITEM_TYPE_VIEW_IN_A_ROOM_IMAGE:
            return wrapWithThumbComponent(
              currentTab,
              index,
              galleryItem.description || `View in a room image ${index + 1}`,
              currentItem,
              <ViewInARoomThumb>
                <ViewInARoomSized
                  imageUrl={galleryItems[0].imageUrl}
                  title={title}
                  selectedProduct={selectedProduct}
                  abTest={{}}
                  isClientReady={isClientReady}
                />
              </ViewInARoomThumb>
            )

          case GALLERY_ITEM_TYPE_ARTIST_VIDEO:
            const { videoThumbnailUrl } = galleryItem

            return wrapWithThumbComponent(
              currentTab,
              index,
              'View artist video',
              currentItem,
              <img
                className='lazyload'
                data-src={videoThumbnailUrl}
                alt='View artist video'
                src={rendered ? videoThumbnailUrl : undefined}
              />
            )

          default:
            const { description, thumbnailUrl } = galleryItem

            return wrapWithThumbComponent(
              currentTab,
              index,
              description || `view additional image ${index + 1}`,
              currentItem,
              <img
                className='lazyload'
                data-src={thumbnailUrl}
                alt={description || `view additional image ${index + 1}`}
                src={rendered ? thumbnailUrl : undefined}
              />
            )
        }
      })}

      <ARExperience />

      {canEditArtwork && (
        <AddArtwork onClick={clickAddArtworkThumbnail}>
          <PlusIcon />
          <p>
            Add
            <br />
            Image
          </p>
        </AddArtwork>
      )}
    </Thumbnails>
  )
}

export default GalleryThumbnailsConnector(Component)
